import { useCallback } from 'react'

import { getConfiguration } from 'services/config'

export const useLoginProvider = () => {
  const { loginUrl, logoutUrl, loginParams } = getConfiguration()

  const redirectToLogin = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const newUrl = new URL(loginUrl, window.location.origin)
    loginParams.forEach((param) => {
      const value = urlParams.get(param)
      if (value) {
        newUrl.searchParams.append(param, value)
      }
    })

    window.location.replace(newUrl.toString())
  }, [loginUrl, loginParams])

  const redirectToLogout = useCallback(() => {
    window.location.replace(logoutUrl)
  }, [logoutUrl])

  return {
    redirectToLogin,
    redirectToLogout,
  }
}
